import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { updateUserTempPassword } from '@src/api'
import {
  AuthenticationResponse,
  DefaultApiUpdateUserTempPasswordRequest,
} from '@src/api/generated/iam'
import { useAxios } from '@src/hooks/use-axios'

import { UpdateTempPasswordError } from './type'

export const useUpdateUserTempPassword = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useMutation<
    AxiosResponse<AuthenticationResponse>,
    AxiosResponse<UpdateTempPasswordError>,
    DefaultApiUpdateUserTempPasswordRequest
  >({
    mutationFn: (params: DefaultApiUpdateUserTempPasswordRequest) =>
      updateUserTempPassword(axiosInstance, params),
  })
}
